import React, { Component } from 'react';
import { PageHeader } from 'components/page-header';
import { Page } from 'components/page-container';
import { Filters } from 'modules/filters/containers/Filters';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { IStore } from 'reducers/index';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { connect } from 'react-redux';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import { fetchExceptions, sendReprocess, requestFile, resetExceptionLogs, toggleReprocess } from 'actions/exception-management';
import { IEventLog, IEventLogsAction } from 'reducers/event-logs/models';
import { setSort, resetSort } from 'actions/filters';
import { ISortModel } from 'reducers/filters/models';
import { setSortForTable } from 'utilities/tables';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { ExceptionManagement } from 'components/exception-management/ExceptionManagement';
import { INickname } from 'reducers/nickname';
import InPageDialog from '../../../components/page-dialog';
import { RouteComponentProps, withRouter } from 'react-router';
import { cols, TABS } from 'components/exception-management/constants';
import { parseQuery } from 'utilities/util';
import {
    applyFiltersAction,
    setFilter
} from 'actions/filters';
import { ISort } from 'views/job-costing/search/models';
import API from 'constants/api';
import { callApiPost } from 'utilities/apiCaller';
import { ModalMain } from 'damco-components';

const completed = 'completed';
interface IMapState {
    data: IEventLogsAction;
    isLoading: boolean;
    filters: any;
    nickname: INickname;
    blob: any,
    error: any,
    reprocess: any;
}

interface IMapDispatch {
    fetchExceptions: (pageNumber: number, pageSize: number) => Promise<void>;
    resetExceptionLogs: () => void;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
    sendReprocess: (id: any, userId: string) => void;
    toggleReprocess: (id: any, userId: string) => void;
    requestFile: (id: any, userId: string) => void;
    setFilter: (name: string, value: string | boolean | any[] | number) => void;
    applyFilters: () => void;
}

interface IExceptionsProps extends RouteComponentProps, IMapState, IMapDispatch { }

interface IExceptionsState {
    sorted: any[] | ISort[];
    fetchInProgress: boolean,
    selectedEventLog?: IEventLog;
    page: number;
    pageSize: number;
    data: any[],
    file: any,
    activeTab: number,
    timeofrequest: number,
    showDialog: boolean,
    message: string,
    isError: boolean,
    filterKey: string,
    filterValue: string;
    downloadRecordCount?: number;
    showOpenExceptionsBulkDownloadModal: boolean;
}

export class _Exceptions extends Component<IExceptionsProps, IExceptionsState> {
    public state = {
        sorted: [],
        fetchInProgress: false,
        selectedEventLog: undefined,
        page: 1,
        pageSize: 10,
        activeTab: 0,
        timeofrequest: 0,
        file: '',
        showDialog: false,
        data: [],
        message: '',
        isError: true,
        filterKey: '',
        filterValue: '',
        showOpenExceptionsBulkDownloadModal: false,
    };
    public unlisten: any;
    public componentDidMount() {
        const url = this.props.location.pathname;
        if (url.endsWith('closed-exceptions')) {
            this.handleTabChange(2);
        } else {
            this.handleTabChange(1);
        }
        this.unlisten = this.props.history.listen((location, action) => {
            this.checkRedirect();
        });
    }
    public componentWillUnmount() {
        this.props.resetSort();
        this.unlisten();
        this.props.resetExceptionLogs();
    }
    public componentDidUpdate(props: any, state: any) {
        if (this.props.data !== props.data) {
            this.setState({
                fetchInProgress: false
            });
        }
        if (this.props.error !== props.error && this.props.error) {
            this.setState({
                fetchInProgress: false,
                showDialog: true,
                isError: true,
                message: this.props.error
            });
        }
        if (this.props.reprocess && this.props.reprocess !== props.reprocess) {
            this.fetchEventsList({ page: 0, pageSize: this.state.pageSize });
        }
        if (this.state.activeTab !== state.activeTab) {
            if (this.state.activeTab === 2) {
                this.props.setFilter('status', completed);
            } else {
                this.props.setFilter('status', '');
            }
            this.props.applyFilters();
            this.props.resetExceptionLogs();
            setTimeout(() => this.fetchEventsList({ page: 0, pageSize: this.state.pageSize }), 500);
        }
    }
    public handleTabChange = (e: number) => {
        const nextURL = e === 1 ? 'open-exceptions' : 'closed-exceptions';
        this.setState({ activeTab: e });
        this.props.history.push(`/exception-management/exceptions/${nextURL}`);
    };
    public render() {
        return (
            <React.Fragment>
                <PageHeader>Exception Management</PageHeader>
                <Page>
                    <div className={'padding-top-xLarge'}>
                        <Filters
                            tableNameKey="fact"
                            fetchFunction={() => {
                                this.setState({
                                    showDialog: false
                                });
                                this.fetchEventsList({ page: 0, pageSize: this.state.pageSize });
                            }}
                            resetErrors={() => this.setState({ activeTab: 1 })}
                            filters={[
                                <FiltersInput
                                    name="documentNumber"
                                    label="Document Number"
                                    key="documentNumber"
                                />,
                                <FiltersSelect
                                    key="documentType"
                                    name="documentType"
                                    label="Document Type"
                                    options={[
                                        { optionText: 'Booking', label: 'Booking', value: 'booking' },
                                        { optionText: 'Document', label: 'Document', value: 'document' },
                                        { optionText: 'CBL', label: 'CBL', value: 'cbl' },
                                        { optionText: 'CLR', label: 'CLR', value: 'clr' },
                                        { optionText: 'ETS', label: 'ETS', value: 'ets' },
                                        { optionText: 'Events And Milestones', label: 'Events And Milestones', value: 'EventsAndMilestones' },
                                        { optionText: 'ITM', label: 'ITM', value: 'itm' },
                                        { optionText: 'Transport order', label: 'Transport order', value: 'TransportOrder' },
                                        { optionText: 'Invoice', label: 'Invoice', value: 'invoice' },
                                        { optionText: 'Auto Charge', label: 'Auto Charge', value: 'AutoCharge' },
                                        { optionText: 'ICP Automation', label: 'ICP Automation', value: 'ICPAutomation' },
                                        { optionText: 'Supplier Invoice', label: 'Supplier Invoice', value: 'SupplierInvoice' },
                                        { optionText: 'Invoice Payment', label: 'Invoice Payment', value: 'InvoicePayment' },
                                        { optionText: 'MCI', label: 'MCI', value: 'MCI' }
                                    ]}
                                />,
                                <FiltersSelect
                                    key="status"
                                    name="status"
                                    label="Status"
                                    options={[
                                        { optionText: 'New', label: 'New', value: 'new' },
                                        { optionText: 'Error', label: 'Error', value: 'error' },
                                        { optionText: 'System Close', label: 'System Close', value: 'SystemClose' },
                                        { optionText: 'Blob Url Error Close', label: 'Blob Url Error Close', value: 'BlobUrlErrorClose' },
                                        { optionText: 'Completed', label: 'Completed', value: completed }]
                                    }
                                />,
                                <FiltersDateInput
                                    name="dateFrom"
                                    label="Date (from)"
                                    key="dateFrom"
                                    type="date"
                                    withTime={false}
                                />,
                                <FiltersDateInput
                                    name="dateTo"
                                    label="Date (to)"
                                    key="dateto"
                                    type="date"
                                    withTime={false}
                                />,
                                <FiltersInput
                                    key="consignee"
                                    name="consignee"
                                    id="consignee"
                                    label="Consignee"
                                />
                            ]}
                        />
                        <TabComponent activeTab={this.state.activeTab - 1} name="search-filters" navLinks={TABS} callbackFc={(e: number) => {
                            this.handleTabChange(e);
                        }
                        } />
                        <InPageDialog
                            showDialog={this.state.showDialog}
                            type={this.state.isError ? 'error' : 'success'}
                            message={this.state.message}
                            closeMethod={() => this.setState({ showDialog: false, isError: true })}
                        />
                        {this.state.showOpenExceptionsBulkDownloadModal &&
                            <div className="exceptions-bulk-actions-modal">
                                <ModalMain
                                    modal={this.state.showOpenExceptionsBulkDownloadModal}
                                    title={'Bulk Download Open Exceptions'}
                                    hideMethod={() => this.setState({ showOpenExceptionsBulkDownloadModal: false })}
                                    secondaryMethod={() => this.setState({ showOpenExceptionsBulkDownloadModal: false })}
                                    primaryMethod={() => {
                                        this.setState({ showOpenExceptionsBulkDownloadModal: false });
                                        const pageSize = this.props.data.totalCount > 2000 ? 2000 : this.props.data.totalCount;
                                        this.handleOpenExceptionsBulkDownload(pageSize);
                                    }}
                                    btnTitle1={'Continue'}
                                    btnTitle2={'Cancel'}
                                >
                                    Note : Only first 2,000 records can be downloaded. Please apply additional filters to reduce the total number of results. Click 'Continue' to download the first 2,000 records.
                                </ModalMain>
                            </div>
                        }
                        {
                            this.props.location.pathname.endsWith('open-exceptions') &&
                            <div className="exceptions-bulk-actions">
                                <button type="button" className="button button-blue" onClick={this.handleOpenExceptionsBulkDownloadModalOpen}>Bulk Download Open Exceptions</button>
                            </div>
                        }
                        <ExceptionManagement
                            file={this.props.blob}
                            cols={cols}
                            calculateAging={true}
                            fetchData={this.fetchEventsList}
                            data={this.props.data.result}
                            sendReprocess={(id: any) => this.reprocessHandle(id)}
                            toggleReprocess={(id: any) => this.toggleReprocessHandle(id)}
                            pageCount={Math.ceil(this.props.data.totalCount / this.state.pageSize)}
                            linkAction={(id: any) => this.props.requestFile(id, this.props.nickname.employeeId)}
                        />
                    </div>
                </Page>
            </React.Fragment>
        );
    }
    private checkRedirect = () => {
        const list: any = parseQuery();
        let id: number = 1;
        // tslint:disable-next-line: forin
        if (list && list.length > 0) {
            for (const { key, value } of list) {
                if (key === 'status' && value === completed) {
                    id = 2;
                }
            }
            this.setState({ activeTab: id });
        }
    };
    private reprocessHandle = (id: any) => {
        this.props.sendReprocess(id, this.props.nickname.employeeId);
        const selected: any[] = this.props.data.result.filter((el: any) => el.historyLogId === id);
        this.setState({
            showDialog: true,
            isError: false,
            message: `Reprocess ${selected[0] ? selected[0].documentNumber : id} has been submitted successfully. Please refresh the page.`
        });
    };
    private toggleReprocessHandle = (id: any) => {
        this.props.toggleReprocess(id, this.props.nickname.employeeId);
        const selected: any[] = this.props.data.result.filter((el: any) => el.historyLogId === id);
        this.setState({
            showDialog: true,
            isError: false,
            message: `Reset reprocess ${selected[0] ? selected[0].documentNumber : id} has been submitted successfully. Please refresh the page.`
        });
    };
    private fetchEventsList = (tableData: any) => {
        const samePageRequest = (tableData.page + 1 !== this.state.page || tableData.pageSize !== this.state.pageSize) || (new Date().getTime() - this.state.timeofrequest) > 500;
        if (this.state.activeTab !== 0 && samePageRequest && !this.state.fetchInProgress) {
            this.setState({
                page: tableData.page + 1,
                pageSize: tableData.pageSize,
                timeofrequest: new Date().getTime(),
                fetchInProgress: true
            }, () => {
                if (tableData && tableData.sorted && tableData.sorted.length > 0 && (tableData.sorted[0].id === 'errorDetails' || tableData.sorted[0].id === 'messageDetails')) {
                    this.setState({ fetchInProgress: false });
                    return;
                }
                if (tableData && tableData.sorted) {
                    this.setState({ sorted: tableData.sorted });
                    setSortForTable(tableData.sorted, this.props.setSort);
                } else if (this.state.sorted && this.state.sorted.length) {
                    setSortForTable(this.state.sorted, this.props.setSort);
                }
                this.props.fetchExceptions(this.state.page, this.state.pageSize);
            });
        }
    };

    private handleOpenExceptionsBulkDownloadModalOpen = () => {
        if (this.props.data.totalCount > 2000) {
            this.setState({ showOpenExceptionsBulkDownloadModal: true });
            return;
        }
        this.handleOpenExceptionsBulkDownload(this.props.data.totalCount);
    }

    private handleOpenExceptionsBulkDownload = async (pageSize: number) => {
        this.setState({ fetchInProgress: true });

        try {
            const response = await callApiPost(
                API.EXCEPTION.BulkDownloadOpenExceptions,
                this.buildDownloadPayload(pageSize),
                { responseType: 'arraybuffer' }
            );

            if (!response || !response.data) {
                throw new Error('Invalid response received from server');
            }

            const fileName = this.extractFileName(response.headers?.['content-disposition']);
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            this.downloadFile(blob, fileName);
            this.setState({
                showDialog: true,
                isError: false,
                message: 'Download completed successfully'
            });

        } catch (error) {
            this.setState({
                showDialog: true,
                isError: true,
                message: 'Bulk download of open exceptions failed'
            });
        } finally {
            this.setState({ fetchInProgress: false });
        }
    }

    private parseDocumentNumbers = (input: string): string[] => {
        if (!input || typeof input !== 'string' || !input.trim()) {
            return [];
        }

        // Split by comma and/or whitespace, filter empty values
        return input
            .split(/[\s,]+/)
            .filter(num => num.length > 0);
    };

    private buildDownloadPayload = (pageSize: number) => {
        const filters = this.props.filters || {};
        const documentNumbersInput = filters.documentNumber || filters.DocumentNumber || '';

        return {
            UserId: this.props.nickname?.employeeId || '',
            PageNumber: this.state.page,
            Page: this.state.page,
            PageSize: pageSize,
            AllowedBackendPageSize: true,
            Filters: {
                documentNumbers: this.parseDocumentNumbers(documentNumbersInput),
                documentType: filters.documentType || filters.DocumentType || '',
                dateFrom: filters.dateFrom || filters.DateFrom || '',
                dateTo: filters.dateTo || filters.DateTo || '',
                consignee: filters.consignee || filters.Consignee || '',
                status: filters.status || filters.Status || ''
            },
            Sorting: {
                column: 'createTime',
                order: 'asc'
            }
        };
    }

    private extractFileName = (contentDisposition?: string): string => {
        if (!contentDisposition) {
            return 'OPEN_EXCEPTIONS_BULK_DOWNLOAD';
        }

        const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+?)(?:;|$)/i);
        if (utf8Match) {
            return decodeURIComponent(utf8Match[1])
        }

        const match = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/i);
        return match ? match[1] : 'OPEN_EXCEPTIONS_BULK_DOWNLOAD';
    }

    private downloadFile = (blob: Blob, fileName: string): void => {
        if (!blob) {
            console.error('Invalid blob provided for download');
            return;
        }

        const safeFileName = fileName || 'OPEN_EXCEPTIONS_BULK_DOWNLOAD';
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${safeFileName}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }
}

const mapStateToProps = (state: IStore): IMapState => ({
    isLoading: state.exceptions.isFetchDataLoading,
    data: state.exceptions.exceptions,
    filters: state.filters.filters,
    nickname: state.nickname.userNickName,
    blob: state.exceptions.file,
    error: state.exceptions.errors,
    reprocess: state.exceptions.reprocess
});

const mapDispatch = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatch => ({
    fetchExceptions: (pageNumber: number, pageSize: number) => dispatch(fetchExceptions(pageNumber, pageSize)),
    resetExceptionLogs: () => dispatch(resetExceptionLogs()),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    requestFile: (id: any, userId: string) => dispatch(requestFile(id, userId)),
    sendReprocess: (id: any, userId: string) => dispatch(sendReprocess(id, userId)),
    toggleReprocess: (id: any, userId: string) => dispatch(toggleReprocess(id, userId)),
    setFilter: (name: string, value: string | boolean | any[] | number) => dispatch(setFilter(name, value)),
    applyFilters: () => dispatch(applyFiltersAction()),
});

export const __Exceptions = connect<IMapState, IMapDispatch, {}, IStore>(mapStateToProps, mapDispatch)(_Exceptions);
export const Exceptions = withRouter(__Exceptions);